import { cn } from "@/lib/utils";

const LOGO_BASE = "/assets/Scrubmee_Logo_Pack/Transparent_SVG";

const logoSources = {
  horizontal: {
    dark: `${LOGO_BASE}/Scrubmee_Horizontal_Full_Logo_Light_Enhanced.svg`,
    light: `${LOGO_BASE}/Scrubmee_Horizontal_Full_Logo_Dark_Enhanced.svg`,
  },
  wordmark: {
    dark: `${LOGO_BASE}/Scrubmee_Wordmark_Light_Enhanced.svg`,
    light: `${LOGO_BASE}/Scrubmee_Wordmark_Dark_Enhanced.svg`,
  },
  icon: {
    dark: `${LOGO_BASE}/Scrubmee_Icon_Light.svg`,
    light: `${LOGO_BASE}/Scrubmee_Icon_Dark.svg`,
  },
} as const;

type LogoVariant = keyof typeof logoSources;
type LogoTone = "light" | "dark";

interface ScrubmeeLogoProps {
  variant?: LogoVariant;
  tone?: LogoTone;
  className?: string;
  decorative?: boolean;
}

export function ScrubmeeLogo({
  variant = "horizontal",
  tone = "dark",
  className,
  decorative = false,
}: ScrubmeeLogoProps) {
  return (
    <img
      src={logoSources[variant][tone]}
      alt={decorative ? "" : "Scrubmee"}
      className={cn("block object-contain", className)}
      loading="eager"
      decoding="async"
      aria-hidden={decorative || undefined}
    />
  );
}

export { logoSources };
